import IBAN from 'iban'

import { getVatNoRegex } from '../../../utils/getVatNoRegex'
import { EInvoiceAddressSchemeType } from '../enums/eInvoiceAddressSchemeType'

// LWID: regex mentioned in https://docs.peppol.eu/edelivery/codelists/old/v8.5/Peppol%20Code%20Lists%20-%20Participant%20identifier%20schemes%20v8.5.html
const LWID_REGEX = /[0-9]{2,12}(-[0-9A-Z]{0,30})?-[0-9]{2}/
// DUNS: exactly 9 digits, only numbers
const DUNS_REGEX = /^\d{9}$/
// GLN: 7, 8, or 9 digits, only numbers
const GLN_REGEX = /^\d{7,9}$/
// SIREN: 9 digits, only numbers
const SIRENE_REGEX = /^\d{9}$/

export const isValidEInvoiceAddressFormat = (
  address: string | undefined,
  scheme: EInvoiceAddressSchemeType | undefined,
  country?: string | undefined,
): boolean => {
  if (!address || !scheme || !country) {
    return true
  }
  switch (scheme) {
    case EInvoiceAddressSchemeType.LWID:
      return LWID_REGEX.test(address)
    case EInvoiceAddressSchemeType.DUNS:
      return DUNS_REGEX.test(address)
    case EInvoiceAddressSchemeType.GLN:
      return GLN_REGEX.test(address)
    case EInvoiceAddressSchemeType.SIRENE:
      return SIRENE_REGEX.test(address)
    case EInvoiceAddressSchemeType.IBAN:
      return IBAN.isValid(address)
    case EInvoiceAddressSchemeType.VAT:
      return getVatNoRegex(country).test(address)
    default:
      return true
  }
}
